import React from 'react';
import { theme } from '../theme';
import { pillStyle, INFO_PILL_BORDER_WIDTH } from './SecondaryAxisPills';
import { FORM_WORD } from '../words';

// <purpose>THE „Formular" pill (part 7 fix loop, 2026-10-12, operator ruling — ROW COMPOSITION v1):
// the mail carries an attached form the pipeline recognised and converts to an Excel row. It is the
// form-extraction tenant's TENANT-EXCLUSIVE plum pill, so it opens row 3's left group exactly where
// the sender pill opens it on a sender-registry tenant. The extraction already existed (the
// Excel-batch button, the detail's row copy); only the row's statement of it was missing.</purpose>
// <dependencies>theme.partnerPill.ink (the plum register the sender pill wears) · pillStyle('info',
// 'row') + INFO_PILL_BORDER_WIDTH for the metrics, so it stands exactly as tall as its siblings.</dependencies>
// <constraints>Part 7 fix loop, 2026-10-12:
//   - Outlined, plum ink on white, solid border — the SenderPill's register and metrics; never
//     filled, so it never competes with the classification badge.
//   - The CALLER gates it (TicketRowMeta: the clerk's „Formular" switch, the row's
//     `hasFormExtraction`, and the served `formExtractionEnabled` capability via useCategoryMeta) —
//     never a role id. This component draws; it does not decide.
//   - „Formular" is a product word, not a served tenant word: form extraction is a capability, not
//     a vocabulary value, so no tenant serves a face for it. Spelled ONCE (constants.FORM_WORD), shared
//     with the row-pill switch and the filter bubble.
//   - The pill carries NO hover (part 7 round 3, 2026-10-14: an info pill hovers a served explanation
//     or nothing): „Formular" is the whole fact until a form kind is served. So the reserved slot and
//     the pill are ONE bare span across the flip, with no tooltip anchor and no tab stop.
//   - THE RESERVATION (review round 1, 2026-10-12): the capability flag is never cached, so on a
//     warm load rows paint before /config answers. While `cm.capabilitiesLoading`, a form-bearing
//     row mounts this pill `reserved` — its exact footprint at `visibility: hidden` — so when the
//     capability lands ON the pill appears IN PLACE (fading in) and nothing beside it moves; when
//     it lands OFF the reservation collapses (a historical extraction on a tenant that switched
//     form extraction off — core serves hasFormExtraction from the stored extraction alone). Same
//     pattern as AttachmentGlyphSlot. Rows with no form reserve nothing.</constraints>
export const FormPill: React.FC<{ style?: React.CSSProperties; reserved?: boolean }> = ({ style, reserved = false }) => {
  const ink = theme.partnerPill.ink;
  return (
    <span
      // `reserved` = the pill's exact footprint, invisible, while the capability is unknown (see
      // <constraints>); the same element becomes the pill in place once it is known.
      data-testid={reserved ? 'form-pill-slot' : 'form-pill'}
      aria-hidden={reserved ? true : undefined}
      style={{
        ...pillStyle('info', 'row'),
        color: ink,
        backgroundColor: theme.colors.white,
        border: `${INFO_PILL_BORDER_WIDTH} solid ${ink}`,
        boxSizing: 'border-box',
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        whiteSpace: 'nowrap',
        // The fade belongs to the VISIBILITY FLIP (part 7 fix loop, 2026-10-12): the reserved slot is
        // hidden, so an animation running on it would be spent before the capability lands and the
        // pill would snap in. Setting the animation only once `reserved` turns false starts it then.
        animation: reserved ? 'none' : 'stx-fadeIn 0.3s ease',
        ...(reserved ? { visibility: 'hidden' as const } : null),
        ...style,
      }}
    >
      {FORM_WORD}
    </span>
  );
};
